'use client';

import { VStack } from '@terra/ui-styled-system';
import {
  LabelDefault,
  MetaDefault,
  MonoSmall,
} from '../../../../../components/typography';

export function HitlLabeledValues({
  label,
  values,
}: {
  label: string;
  values: string[];
}) {
  return (
    <VStack alignItems="stretch" gap={1} width="100%">
      <LabelDefault color="fg.muted">{label}</LabelDefault>
      {values.map((value) => (
        <MonoSmall key={value} color="fg.default">
          {value}
        </MonoSmall>
      ))}
    </VStack>
  );
}

export function HitlLabeledValue({
  label,
  value,
}: {
  label: string;
  value: string;
}) {
  return (
    <VStack alignItems="stretch" gap={1} width="100%">
      <LabelDefault color="fg.muted">{label}</LabelDefault>
      <MetaDefault color="fg.default">{value}</MetaDefault>
    </VStack>
  );
}
